import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { injectCss } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import styled, { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
    marginLeft = "marginLeft",
    marginTop = "marginTop",
    marginRight = "marginRight",
    marginBottom = "marginBottom",
    wrapperClassName = "wrapperClassName",
}

interface OwnProps extends WidgetProps {
    fields: {
        backgroundColor: string;
        marginLeft: string;
        marginTop: string;
        marginRight: string;
        marginBottom: string;
        wrapperClassName: string;
    };
}

interface WrapperWithMargin {
    container?: InjectableCss;
    wrapper?: InjectableCss;
}

export const styles: WrapperWithMargin = {
    container: {},
};

const WrapperWithMargin: FC<OwnProps> = ({ fields, id }) => {
    const { backgroundColor, marginLeft, marginTop, marginRight, marginBottom, wrapperClassName } = fields;
    return (
        <StyledWrapper {...styles.container} className={wrapperClassName}>
            <ContentWrapper
                backgroundColor={backgroundColor}
                marginLeft={marginLeft}
                marginTop={marginTop}
                marginRight={marginRight}
                marginBottom={marginBottom}
            >
                <Zone zoneName="Content" contentId={id} />
            </ContentWrapper>
        </StyledWrapper>
    );
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: WrapperWithMargin,
    definition: {
        group: "Common",
        displayName: "Wrapper with margin",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.marginLeft,
                editorTemplate: "TextField",
                displayName: "Margin Left",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.marginTop,
                editorTemplate: "TextField",
                displayName: "Margin Top",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.marginRight,
                editorTemplate: "TextField",
                displayName: "Margin Right",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.marginBottom,
                editorTemplate: "TextField",
                displayName: "Margin Bottom",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.wrapperClassName,
                editorTemplate: "TextField",
                displayName: "Wrapper Class Name",
                defaultValue: "",
                tab: advancedTab,
            },
        ],
    },
};

export default widgetModule;

export const ContentWrapper = styled.div<
    {
        backgroundColor: string;
        marginLeft: number | string;
        marginTop: number | string;
        marginRight: number | string;
        marginBottom: number | string;
    } & InjectableCss
>`
    ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor};` : null)};
    ${({ marginLeft }) => (marginLeft ? `margin-left: ${marginLeft}px;` : null)};
    ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : null)};
    ${({ marginRight }) => (marginRight ? `margin-right: ${marginRight}px;` : null)};
    ${({ marginBottom }) => (marginBottom ? `margin-bottom: ${marginBottom}px;` : null)};
`;
